import React from 'react';
import './index.css';
import Navbar from '../Navbar2';
import Contact from '../Contact';
import Register from '../Register';

const Sign = () => {
    return (
        <>
        <Navbar/>
        <div className='pt-5 container-color' style={{background:'rgb(248, 249, 244)'}}>
            <Register/>
            <Contact/>  
        </div>
        </>
    );
}

export default Sign;
